import {AfterViewInit, Component, ElementRef, Input, ViewChild} from '@angular/core';

@Component({
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.scss'],
    standalone: false
})
export class TooltipComponent implements AfterViewInit {

  @ViewChild('tooltip') tooltipRef: ElementRef;

  @Input() host: HTMLElement;
  @Input() content: string;
  @Input() maxHeight: string;
  @Input() position: 'top'|'bottom'|'left'|'right'|'custom'|'dropdown';
  @Input() align: 'top'|'bottom'|'left'|'right'|'center';
  @Input() color: 'default'|'green'|'black';
  @Input() delay: number;

  public tooltipStyle: any;

  constructor() {
    this.tooltipStyle = {};
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.content = this.content.length > 205 ? this.content.substring(0, 205) + '...' : this.content;
    }, 50);
    const hostBoundingBox: ClientRect = this.host.getBoundingClientRect();
    const tooltipBoundingBox: ClientRect = this.tooltipRef.nativeElement.getBoundingClientRect();
    let top: number;
    let left: string;
    let right: string;

    // TODO: implement align top and bottom
    switch (this.position) {
      case 'top':
        top = hostBoundingBox.top - tooltipBoundingBox.height;

        switch (this.align) {
          case 'left':
            left = hostBoundingBox.left + 'px';
            right = 'auto';
            break;

          case 'right':
            left = 'auto';
            right = hostBoundingBox.right + 'px';
            break;

          default:
            left = (hostBoundingBox.left + hostBoundingBox.width / 2 - tooltipBoundingBox.width / 2) + 'px';
            right = 'auto';
            break;
        }
        break;

      case 'bottom':
        top = hostBoundingBox.bottom;

        switch (this.align) {
          case 'left':
            left = hostBoundingBox.left + 'px';
            right = 'auto';
            break;

          case 'right':
            left = 'auto';
            right = hostBoundingBox.right + 'px';
            break;

          default:
            left = (hostBoundingBox.left + hostBoundingBox.width / 2 - tooltipBoundingBox.width / 2) + 'px';
            right = 'auto';
            break;
        }
        break;

      case 'left':
        top = hostBoundingBox.top + hostBoundingBox.height / 2 - tooltipBoundingBox.height / 2;
        left = (hostBoundingBox.left - tooltipBoundingBox.width) + 'px';
        break;

      case 'right':
        top = hostBoundingBox.top + hostBoundingBox.height / 2 - tooltipBoundingBox.height / 2;
        left = hostBoundingBox.right + 'px';
        break;

      case 'custom':
        top = hostBoundingBox.top;
        left = hostBoundingBox.left + 'px';
        break;

      case 'dropdown':
        top = hostBoundingBox.bottom + 5;
        left = hostBoundingBox.left + hostBoundingBox.width  - tooltipBoundingBox.width + 'px';
        break;

    }

    setTimeout((): void => {
      this.tooltipStyle = {
        top: top + 'px',
        right: right,
        left: left,
        maxHeight: this.maxHeight
      };
    }, this.delay || 0);
  }

}
